// src/components/AgentDecisionBanner.js
// FASE 1: banner que aparece no topo da área "ajudar manualmente" quando o
// agente IA já tomou uma decisão sobre a empresa. Força reconhecimento humano
// antes de permitir override via hint manual.

import React from 'react';

export default function AgentDecisionBanner({ lastDecision, overrideConfirmed, onOverrideConfirm, onDismiss }) {
  if (!lastDecision) return null;

  const isSkip = lastDecision.recommendation === 'skip';
  const bg = isSkip ? 'bg-amber-50 border-amber-200' : 'bg-emerald-50 border-emerald-200';
  const iconBg = isSkip ? 'bg-amber-100 text-amber-700' : 'bg-emerald-100 text-emerald-700';
  const label = isSkip ? 'classificada como NÃO-APLICÁVEL ao Apollo' : 'classificada como enriquecível';
  const reason = lastDecision.skip_reason || lastDecision.reasoning;

  const when = new Date(lastDecision.created_at).toLocaleString('pt-BR', {
    day: '2-digit', month: '2-digit', year: 'numeric',
    hour: '2-digit', minute: '2-digit',
  });

  return (
    <div className={`${bg} border rounded-md p-3 mb-3`}>
      <div className="flex items-start gap-2">
        <div className={`${iconBg} rounded-full w-6 h-6 flex items-center justify-center text-sm shrink-0`}>
          🤖
        </div>
        <div className="flex-1 text-sm">
          <div className="font-medium text-slate-900">
            Agente IA já analisou esta empresa — {label}
          </div>
          <div className="text-slate-600 mt-0.5 text-xs">
            em {when} · confiança {(lastDecision.confidence * 100).toFixed(0)}%
          </div>
          {reason && (
            <div className="text-slate-700 mt-1.5 italic text-xs leading-relaxed">
              "{reason}"
            </div>
          )}
          {isSkip && !overrideConfirmed && (
            <div className="mt-2 flex gap-2">
              <button
                onClick={onOverrideConfirm}
                className="text-xs px-3 py-1 bg-white border border-amber-300 rounded hover:bg-amber-100 text-amber-800"
              >
                Discordar e forçar enrich mesmo assim
              </button>
              {onDismiss && (
                <button
                  onClick={onDismiss}
                  className="text-xs px-3 py-1 text-slate-500 hover:text-slate-700"
                >
                  Fechar
                </button>
              )}
            </div>
          )}
          {isSkip && overrideConfirmed && (
            <div className="mt-2 text-xs text-amber-800 font-medium">
              ⚠️ Override ativado — ações manuais abaixo estão habilitadas.
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
